import React from 'react';
import { Users, BookOpen, Star, ShieldCheck } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
export function FeaturedIn() {
  const {
    t
  } = useLanguage();
  const publications = ['Bon Appétit', 'Saveur', 'Food & Wine', 'Travel + Leisure', 'Eater', 'Condé Nast Traveler'];
  const stats = (t('featuredIn.stats') as unknown as {
    value: string;
    label: string;
  }[]).map((stat, i) => {
    const icons = [Users, BookOpen, Star, ShieldCheck];
    return {
      ...stat,
      icon: icons[i]
    };
  });
  return <section className="w-full bg-[#3E2723] py-12 md:py-16" data-id="element-232">
      <div className="max-w-6xl mx-auto px-6 md:px-12" data-id="element-233">
        <div className="text-center mb-10" data-id="element-234">
          <div className="text-xs md:text-sm uppercase tracking-[0.3em] text-yellow-300 font-bold mb-6" data-id="element-235">
            {t('featuredIn.title')}
          </div>
          <div className="flex flex-wrap items-center justify-center gap-x-8 md:gap-x-12 gap-y-4" data-id="element-236">
            {publications.map(pub => <div key={pub} className="text-white/70 hover:text-white transition-colors text-base md:text-xl font-bold tracking-wide italic" style={{
            fontFamily: 'DM Serif Display, serif'
          }} data-id="element-237">
                {pub}
              </div>)}
          </div>
        </div>

        <div className="border-t border-white/10 pt-10 mt-10" data-id="element-238">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-8" data-id="element-239">
            {stats.map(stat => {
            const Icon = stat.icon;
            return <div key={stat.label} className="text-center" data-id="element-240">
                  <div className="inline-flex items-center justify-center w-12 h-12 rounded-full bg-[#C2410C] mb-3" data-id="element-241">
                    <Icon className="w-6 h-6 text-yellow-300" data-id="element-242" />
                  </div>
                  <div className="text-3xl md:text-4xl font-extrabold text-white leading-none mb-1" data-id="element-243">
                    {stat.value}
                  </div>
                  <div className="text-xs md:text-sm text-white/70 uppercase tracking-wider" data-id="element-244">
                    {stat.label}
                  </div>
                </div>;
          })}
          </div>
        </div>
      </div>
    </section>;
}